// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2C2Sd","colCheckbox":"styles_colCheckbox__1MGAV"};